<template>
  <div class="container-fluid mt-4">
    <h3 v-show="false">Live Data1 (local): {{ data1 }}</h3>
    <h3 v-show="false">Live Data2 (global): {{ data2 }}</h3>
    <Digi :value="data1" status="success"></Digi>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Digi from "@/Components/Digit";

export default {
  components: {
    Digi
  },
  data() {
    return {};
  },
  async created() {
    this.$store.dispatch("subscribe", { type: "local", channel: "data1" });
    this.$store.dispatch("subscribe", { type: "global", channel: "data2" });
  },
  computed: {
    ...mapState(["error", "data1", "data2"])
  },
  methods: {}
};
</script>
